/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Import_Replace_Not_AllowedInputs */

const en_error_import_replace_not_allowed = /** @type {(inputs: Error_Import_Replace_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lines of this linesheet can no longer be replaced: import the file to add and change lines.`)
};

/**
* | output |
* | --- |
* | "The lines of this linesheet can no longer be replaced: import the file to add and change lines." |
*
* @param {Error_Import_Replace_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_import_replace_not_allowed = /** @type {((inputs?: Error_Import_Replace_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Import_Replace_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_import_replace_not_allowed(inputs)
});